<template>
  <div class="home">
    <div class="home-banner">
      <swiper>
        <swiper-slider>
          <div class="banner-item banner-money">
            <!-- <div class="banner-item-logo logo-money"></div>
            <div class="banner-item-title">{{$t('home.title1')}}</div>
            <div class="banner-item-subTitle">{{$t('home.desc1')}}</div>-->
          </div>
        </swiper-slider>
        <swiper-slider>
          <div class="banner-item banner-des">
            <!-- <div class="banner-item-logo logo-security"></div>
            <div class="banner-item-title">{{$t('home.title2')}}</div>
            <div class="banner-item-subTitle">{{$t('home.desc2')}}</div>-->
          </div>
        </swiper-slider>
        <swiper-slider>
          <div class="banner-item banner-free">
            <!-- <div class="banner-item-logo logo-card"></div>
            <div class="banner-item-title">{{$t('home.title3')}}</div>
            <div class="banner-item-subTitle">{{$t('home.desc3')}}</div>-->
          </div>
        </swiper-slider>
      </swiper>
    </div>
    <div class="phone-wrapper">
      <div class="code">{{ phoneCountryCode }}</div>
      <div class="input">
        <input
          autocomplete="off"
          type="tel"
          v-model="phoneNum"
          :placeholder="$t('home.phonePlaceholder')"
          @keyup="handleKeyUp"
        />
      </div>
    </div>
    <div class="agree-wrapper">
      <i @click="handleClick('agree')" :class="[{ active: isAgree }]"></i>
      <span @click="handleClick('agree')">{{ $t("home.agree0") }}</span>
      <span @click="handleClick('rule')" class="active">{{
        $t("home.agree1")
      }}</span>
    </div>
    <div class="btn-wrapper">
      <a :class="{ active: isCanSubmit }" @click="login">{{ btnTxt }}</a>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlider } from "../base/Swiper";
import { mapMutations, mapState } from "vuex";

import { post, get } from "../../tools/request";
import { fireBase } from "../../tools/utils";
import { SUPPORT_COUNTRY_CONFIG } from "../../tools/constant";
import { showDialog, showAlertDialog, showLoadingToast } from "../../tools/Tip";

import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../../tools/constant";
const REG_PHONE_NUM = /^\d+$/;
export default {
  data() {
    return {
      phoneNum: "",
      isAgree: false,
      phoneNumValidate: false,
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    phoneCountryCode() {
      return (LOGIN_CONFIG[this.location_country]||window.didii18nconfig[this.location_country]).country_calling_code;
    },
    btnTxt() {
      return ends.isFleet
        ? this.$t("login_btn_fleet")
        : this.$t("login_btn_global");
    },
    isCanSubmit() {
      return this.isAgree && this.phoneNumValidate;
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    handleKeyUp() {
      this.validatePhoneNum();
    },
    validatePhoneNum() {
      this.phoneNumValidate = REG_PHONE_NUM.test(this.phoneNum);
    },
    login() {
      if (!this.isCanSubmit) {
        gtm({ 'event': 's1PassportRegister',
          'PhoneNumber': 'invalid',
          'Country': 'AU',
          'error': 'true' })
        return;
      }
      const loginAction = (callback, fallback) => {
        return login.checkPhone(this.phoneNum, callback, fallback);
      };
      try{
        gtm({ 'event': 's1PassportRegister',
          'PhoneNumber': 'valid',
          'Country': 'AU',
          'error': 'false' })
      }catch(e){}
      showLoadingToast(this, this.$t("加载中"), 500);

      loginAction(
        (response) => {
          const { ticket, cell, uid } = response;
          this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });
          //@20190527 新增埋点
          try {
            let p = this.params;
            Omega.trackEvent("tone_p_x_loginCodeResult_rsp", "", {
              driver_id: p.get("driver_id"),
              track_tag: p.get("track_tag"),
              country: p.get("country"),
              city: p.get("city"),
              uid: response.uid,
              campaign: p.get("campaign"),
              term: p.get("term"),
              source: p.get("source"),
              userType: p.get("userType"),
              cell: response.cell,
              lang: p.get("lang"),
              device: p.get("device"),
              medium: p.get("medium"),
              campagin_id: p.get("campagin_id"),
              ad_group_id: p.get("ad_group_id"),
              creative_id: p.get("creative_id"),
            });
            gtag("event", "conversion", {
              send_to: "AW-770894738/VvX6CPTyz5IBEJLXy-8C",
            });
            fireBase("tone_p_x_login_success_sw");
          } catch (e) {}
          if (this.params.get("helpDriverReg") == 1) {
            //fleet 端 车头帮司机注册并绑定的逻辑
            this.handleFleet();
          } else {
            this.$router.replace({ name: "home" });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleFleet() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      up.set("ticket", this._ticket);
      get(process.env.DRIVER_CHECK, {
        params: up,
      })
        .then((data) => {
          //  已注册能绑定 => bindTips
          this.$router.replace({
            name: `bindTip${sc[this.location_country] || "Mx"}`,
            params: {
              driverInfo: data.driver_info,
            },
          });
        })
        .catch((e) => {
          //  未注册 => 跳转到注册页,20002
          const { errmsg, errno } = e;
          if (+errno === 20002) {
            this.$router.replace({ name: "home" });
          } else {
            //  已注册不能绑定 => 错误提示,错误码不等于0且不等于20002
            showAlertDialog(this, errmsg);
            login.logout(
              () => console.log("logout success"),
              (e) => console.log(e)
            );
          }
        })
        .finally((x) => this.toast.hide());
    },

    handleClick(type) {
      switch (type) {
        case "agree":
          this.isAgree = !this.isAgree;
          break;
        case "rule":
          if (this.location_country === "AU") {
            window.location.href = "https://www.didiglobal.com/au/legal.html";
          } else {
            // let lang = SUPPORT_COUNTRY_CONFIG[this.location_country]["lang"];
            let lang = this.params.get("lang");
            window.location.href = `https://common.didiglobal.com/common/v6/driver/law?location_country=${this.location_country}&lang=${lang}`;
          }
        default:
          break;
      }
    },
  },
  components: {
    Swiper,
    SwiperSlider,
  },
  mounted() {
    Omega.trackEvent("tone_p_x_account_loginnew_sw", "", {
      client_user_agent: navigator.userAgent, // 必须
      // client_ip_address: '', // 可选
      fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
      fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
    });
  },
};
</script>
<style  lang="scss" scoped>
@import "../../css/var.scss";
@import "../../css/mixin.scss";
.home {
  width: 100%;
  min-height: 100%;
  background: #fff;
  position: relative;
  font-size: 0.36rem;
  touch-action: none;
  .home-banner {
    // background-image: linear-gradient(-135deg, #fe7947 0%, #ffb984 100%);
    margin-bottom: 0.8rem;
    .banner-item {
      // padding: 0.64rem;
      width: 100%;
      height: 5.2rem;
      text-align: center;
      color: #fff;
      .banner-item-logo {
        margin: 0 auto 0.48rem;
        &.logo-car {
          width: 0.942rem;
          height: 0.546rem;
          background-size: 0.942rem 0.546rem;
          @include bg-img("home-logo-car");
        }
        &.logo-card {
          width: 0.81rem;
          height: 0.546rem;
          background-size: 0.81rem 0.546rem;
          @include bg-img("home-logo-card");
        }
        &.logo-money {
          width: 0.82rem;
          height: 0.742rem;
          background-size: 0.82rem 0.742rem;
          @include bg-img("home-logo-money");
        }
        &.logo-security {
          width: 0.772rem;
          height: 0.893rem;
          background-size: 0.772rem 0.893rem;
          @include bg-img("home-logo-security");
        }
      }
      .banner-item-title {
        font-size: 0.44rem;
        font-weight: 700;
        margin-bottom: 0.48rem;
      }
      .banner-item-subTitle {
        font-size: 0.32rem;
        margin-bottom: 0.48rem;
        line-height: 1.2;
      }
    }
    .banner-money {
      background: url("../../images/banner-money.png") no-repeat;
      background-size: 100% 100%;
    }
    .banner-des {
      background: url("../../images/banner-des.png") no-repeat;
      background-size: 100% 100%;
    }
    .banner-free {
      background: url("../../images/banner-free.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .phone-wrapper {
    padding: 0.34rem 0.4rem;
    display: flex;
    margin-bottom: 0.8rem;
    @include border-1px(bottom);
    @include border-1px(top);
    .code {
      padding: 0.2rem;
      @include border-1px(right);
    }
    .input {
      flex: 1;
      padding-left: 0.34rem;
      input {
        font-size: 0.4rem;
        display: block;
        width: 100%;
        height: 100%;
        background: transparent;
      }
    }
  }
  .agree-wrapper {
    padding: 0 0.4rem;
    margin-bottom: 0.8rem;
    > i {
      display: inline-block;
      vertical-align: middle;
      width: 0.36rem;
      height: 0.36rem;
      background-size: 0.36rem;
      @include bg-img("icon-unchecked");
      &.active {
        @include bg-img("icon-checked");
      }
    }
    > span {
      display: inline-block;
      vertical-align: middle;
      color: #999;
      font-size: 0.25rem;
      &.active {
        color: $main-orange;
      }
    }
  }
  .btn-wrapper {
    padding: 0 0.4rem;
    > a {
      display: block;
      border-radius: 0.12rem;
      padding: 0.33rem 0;
      text-align: center;
      color: #999;
      background: $main-bg-color;
      &.active {
        color: #fff;
        background: $main-orange;
      }
    }
  }
}
</style>

